// extracted by mini-css-extract-plugin
export default {"sectionTitle":"R1hXHi"};